import React, {useState} from 'react';
import './ActionPanel.css';
import {useEffect} from 'react';

const ActionPanel = ({handleSelectedBlock, isAuthenticated, activeBlok}) => {
  const [activeButton, setActiveButton] = useState(null);
  useEffect(() => {
    setActiveButton(setActiveButton);
  }, [activeBlok]);
  return (
    <div className='action-panel'>
      <div className='action-panel__wrapper'>
        {/* Кнопка профиля */}
        <button
          className={`action-panel__btn action-panel__btn_profile ${
            activeButton === 'profile' ? 'active' : ''
          }`}
          style={{
            backgroundColor: `${
              activeButton === 'profile' ? '#9FFF6B' : '#D9D9D9'
            }`,
          }}
          onClick={() => {
            if (isAuthenticated) {
              setActiveButton(activeButton === 'profile' ? null : 'profile');
              handleSelectedBlock(
                activeButton === 'profile' ? null : 'profile'
              );
            } else {
              handleSelectedBlock('sign-in');
            }
          }}
        />
        {/* Кнопка регистрации организации */}
        {isAuthenticated && (
          <button
            className={`action-panel__btn action-panel__btn_organization ${
              activeButton === 'registerOrg' ? 'active' : ''
            }`}
            style={{
              backgroundColor: `${
                activeButton === 'registerOrg' ? '#9FFF6B' : '#D9D9D9'
              }`,
            }}
            onClick={() => {
              if (isAuthenticated) {
                setActiveButton(
                  activeButton === 'registerOrg' ? null : 'registerOrg'
                );
                handleSelectedBlock(
                  activeButton === 'registerOrg' ? null : 'registerOrg'
                );
              } else {
                handleSelectedBlock('sign-in');
              }
            }}
          />
        )}

        {/* Кнопка настроек */}
        <button
          className={
            isAuthenticated
              ? 'action-panel__btn-exit action-panel__btn'
              : `  action-panel__btn ${
                  activeButton === 'add' ? 'action-panel__btn_add-active' : ''
                }`
          }
          style={{
            backgroundSize: 'contain',
          }}
          onClick={() => {
            handleSelectedBlock(
              isAuthenticated
                ? activeButton === 'exit'
                  ? null
                  : 'exit'
                : activeButton === 'add'
                ? null
                : 'sign-in'
            );
            setActiveButton(
              isAuthenticated
                ? activeButton === 'exit'
                  ? null
                  : 'exit'
                : activeButton === 'add'
                ? null
                : 'add'
            );
          }}
        />
      </div>
    </div>
  );
};

export default ActionPanel;
